import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import usePageSeo from '@/hooks/usePageSeo';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import NicheSection from './components/NicheSection';
import TipsSection from './components/TipsSection';
import FaqSection from './components/FaqSection';
import CtaBand from './components/CtaBand';

const faqData = [
  {
    q: '什么是治愈番？',
    a: '治愈番泛指能让人心情放松、感到温暖和治愈的动画，题材多为温馨日常、细腻情感或温柔奇幻。',
  },
  {
    q: '牛奶动漫库的补番目录怎么用？',
    a: '可通过首页搜索框按动画名或标签查找，也可进入治愈番专区或日常番合集按心情快速挑选。',
  },
  {
    q: '日常番和搞笑番有什么区别？',
    a: '日常番侧重描绘平凡生活的细腻悠然，搞笑番则以密集笑点为主，很多作品两者兼具。',
  },
  {
    q: '有哪些适合入坑的萌系动画？',
    a: '推荐《罗小黑战记》《轻松熊和小薰》《请吃红小豆吧！》，可爱又轻松，适合碎片时间观看。',
  },
  {
    q: '看治愈番需要按顺序补吗？',
    a: '大多治愈番为单元剧或独立故事，可随心情挑选；连续剧情的作品建议按年份顺序观看。',
  },
];

export default function Home() {
  const [query, setQuery] = useState('');

  usePageSeo({
    title: '牛奶动漫库 - 治愈番推荐、日常番合集、温馨补番目录',
    description:
      '在牛奶动漫库网，你可以找到治愈系、日常番、萌系动画的完整补番目录，涵盖温馨冷门作与轻松搞笑番，快速追更，无需搜索烦恼。',
    keywords: '牛奶动漫库,治愈番推荐,日常番合集,补番目录,温馨动画,萌系动画',
    canonical: 'https://cartoplist.github.io/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '牛奶动漫库首页',
        url: 'https://cartoplist.github.io/',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '牛奶动漫库热门治愈番推荐',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '夏目友人帐' },
          { '@type': 'ListItem', position: 2, name: '摇曳露营△' },
          { '@type': 'ListItem', position: 3, name: '紫罗兰永恒花园' },
          { '@type': 'ListItem', position: 4, name: '白兔糖' },
          { '@type': 'ListItem', position: 5, name: '元气囝仔' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqData.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
    ],
  });

  const handleSearch = () => {
    const el = document.getElementById('recommend');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onSearch={handleSearch} />
        <CategoryNav />
        <HotSection query={query} />
        <NicheSection />
        <TipsSection />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}